export async function convertImageToWebp(file: File): Promise<File> {
  const isHeic =
    file.type === 'image/heic' ||
    file.type === 'image/heif' ||
    file.name.toLowerCase().endsWith('.heic') ||
    file.name.toLowerCase().endsWith('.heif')

  let sourceBlob: Blob | File = file

  if (isHeic) {
    try {
      // oxlint-disable-next-line unicorn/no-await-expression-member
      const heic2any = (await import('heic2any')).default

      const converted = await heic2any({
        blob: file,
        toType: 'image/jpeg',
        quality: 0.8,
      })
      sourceBlob = Array.isArray(converted) ? converted[0] : converted
      /* eslint-disable @typescript-eslint/no-explicit-any */
    } catch (error: any) {
      if (error.code !== 1) {
        // eslint-disable-next-line no-console
        console.error('HEIC decoding failed:', error)
      }
    }
  }

  // Convert whatever we have (JPEG or converted HEIC) to WebP via Canvas
  return await convertBlobToWebp(sourceBlob, file.name)
}

// oxlint-disable-next-line require-await
async function convertBlobToWebp(blob: Blob, originalName: string): Promise<File> {
  const url = URL.createObjectURL(blob)
  const img = new Image()

  // oxlint-disable-next-line promise/avoid-new
  return new Promise((resolve, reject) => {
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')

      if (!ctx) {
        URL.revokeObjectURL(url)
        reject(new Error('Canvas context failed'))
        return
      }

      ctx.drawImage(img, 0, 0)
      URL.revokeObjectURL(url)

      canvas.toBlob(
        webpBlob => {
          if (!webpBlob) {
            reject(new Error('WebP conversion failed'))
            return
          }
          const newFileName = originalName.replace(/\.[^/.]+$/, '') + '.webp'
          resolve(new File([webpBlob], newFileName, { type: 'image/webp' }))
        },
        'image/webp',
        0.8,
      )
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
      reject(new Error('Image load error'))
    }
    img.src = url
  })
}
